import { Line, mixins } from 'vue-chartjs'
import chartjsPluginAnnotation from "chartjs-plugin-annotation";

export default {
  name: 'TLineChart',
  extends: Line,
  mixins: [mixins.reactiveProp],
  data () {
    return {
      defaultData: {},
      defaultOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
              z: 1
            }
          }],
          yAxes: [{
            gridLines: {
              color: "#dee2e6",
            }
          }]
        },
        tooltips: {
          enabled: true,
          mode: 'index',
          position: 'nearest',
          backgroundColor: '#e7f5ff',
          borderColor: '#74c0fc',
          borderWidth: 1,
          cornerRadius: 0,
          xPadding: 15,
          yPadding: 15,
          titleFontSize: 16,
          titleFontColor: '#339af0',
          titleFontStyle: 'light',
          titleFontFamily: 'Sarabun',
          titleAlign: 'center',
          titleSpacing: 5,
          bodyFontSize: 16,
          bodyFontFamily: 'Sarabun',
          bodyFontColor: '#495057',
          bodyFontStyle: 'bold',
          bodySpacing: 5,
          callbacks: {
            label: function(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              label += Math.round(tooltipItem.yLabel * 100) / 100;
              return label;
            },
          }
        },
        layout: {
          padding: {
            left: 0,
            right: 30,
            top: 30,
            bottom: 10
          }
        }
      }
    }
  },
  props: {
    chartdata: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },

  watch: {
    chartData () {
      this.$data._chart.update()
    }
  },

  mounted () {
    const options = { ...this.defaultOptions, ...this.options }
    const data = { ...this.defaultData, ...this.chartData }
    this.renderChart(data, options)
    this.addPlugin([chartjsPluginAnnotation])
  }
}
